import React from "react";
import {BrowserRouter as Router, withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";

import {withStyles} from "@material-ui/core/styles";
import {CssBaseline} from "@material-ui/core";
import {IntlProvider} from "react-intl";
import axios from "axios";

import TopBar from "./views/top/TopBar";
import SideMenu from "./views/sideBar/SideMenu";
import ScrollToTop from "./components/ScrollToTop";
import * as store from "./stores/AuthStore";
import DialogGroup from "./components/dialogs/DialogGroup";
import RouteList from "./routes";
import LoadingBox from "./views/contents/components/LoadingBox";
import {State} from "./stores/AuthStore";

const style = () => ({
    root: {
        width: '100%',
        minHeight:'100vh',
        display: 'flex',
        background:'#E7E7E7',
        '& *': {
            fontFamily: 'Pretendard !important',
            letterSpacing: '-0.5px'
        },
    }
});

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mobileOpen: false,
        };

        this.setMobileOpen = this.setMobileOpen.bind(this);
    }

    componentDidMount() {
        const axiosRequestInterceptors = (config) => {
            const token = localStorage.getItem(store.LocalStorageTokenKey);

            if(token) {
                config.headers['X-Auth-Token'] = token;
            }

            return config;
        };

        const axiosRequestErrorHandler = (error) => {
            return Promise.reject(error);
        };

        const axiosResponseInterceptor = (response) => {
            if(response.status === 403) {
                this.props.authStore.invalidateLogin();
            }

            return response;
        };

        const axiosResponseErrorHandler = (error) => {
            if((error.response) && (error.response.status === 403)) {
                this.props.authStore.invalidateLogin();
            }

            return Promise.reject(error);
        };

        console.log("========== RGate App componentDidMount ==========");
        axios.interceptors.request.use(axiosRequestInterceptors, axiosRequestErrorHandler);
        axios.interceptors.response.use(axiosResponseInterceptor, axiosResponseErrorHandler);

        this.props.authStore.checkLogin();
    }

    setMobileOpen(mobileOpen) {
        this.setState({mobileOpen: mobileOpen});
    }

    render() {
        const { classes } = this.props;
        const { authStore } = this.props;
        const { loginState } = authStore;
        const { locale, localeMessage } = this.props.localeStore;

        return (
            <IntlProvider messages={localeMessage} locale={locale} defaultLocale={'en'} >
                <div className={classes.root}>
                    <Router>
                        <CssBaseline />
                        <ScrollToTop>
                            <TopBar/>
                            {loginState === State.Authenticated &&
                                <SideMenu/>
                            }
                            <RouteList />
                        </ScrollToTop>
                    </Router>
                    <LoadingBox/>
                    <DialogGroup/>
                </div>
            </IntlProvider>
        );
    }
}


export default withStyles(style)(withRouter(inject('authStore', 'localeStore')(observer(App))));

